export default __webpack_public_path__ + "static/media/ronnie.8dc157e3.jpeg";